import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import FieldMap from '../field-map/FieldMap';
import MobileFieldsPanel from './MobileFieldsPanel';
import FieldsTree from '../left-menu/FieldsTree';
import LayersTree from '../left-menu/LayersTree';
import MobileNavbar from './MobileNavbar';
import { mapModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import { useHideIntercom, useSetFarmSourceEffect } from '../../utils/hooks';
import { LogoDropdown } from '../layout/Header';
import useReadonly from '../../hooks/useReadonly';
import useResetFarmEffect from '../../hooks/useResetFarmEffect';

const FixedPane = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 65px;
  right: 0;
  z-index: 150;
  background-color: var(--background-color);
  overflow: scroll;
`;

const FloatingDiv = styled.div`
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 200;
  width: min-content;
  max-width: 60vw;
`;

const MobileFieldMap = ({ colors }) => {
  useHideIntercom();
  useSetFarmSourceEffect();
  useResetFarmEffect();
  const readonly = useReadonly();

  const [view, setView] = useState('map');
  const {
    mapState: { mapMode },
  } = useContext(MapContext);

  useEffect(() => {
    if (mapMode !== mapModes.VIEW && view !== 'map') setView('map');
  }, [mapMode, view]);

  return (
    <>
      {['map', 'fullscreen-map'].includes(view) ? (
        <FloatingDiv>
          <LogoDropdown
            buttonProps={{ className: 'px-2 w-100', color: 'light' }}
          />
        </FloatingDiv>
      ) : (
        <FixedPane>
          {view === 'sections' && <FieldsTree />}
          {view === 'layers' && <LayersTree addLayerEnabled={!readonly} />}
        </FixedPane>
      )}
      <FieldMap readonly />
      {view === 'map' && (
        <MobileFieldsPanel
          colors={colors}
          onClose={() => setView('fullscreen-map')}
          bottom={
            // Space for the navbar
            mapMode === mapModes.VIEW ? '65px' : undefined
          }
        />
      )}
      {(view !== 'map' || mapMode === mapModes.VIEW) && (
        <MobileNavbar view={view} setView={setView} />
      )}
    </>
  );
};

export default MobileFieldMap;
